module.exports = __webpack_public_path__ + "img/fileIconBlue.ba750af3.png";